module.exports = __webpack_public_path__ + "assets/heatmap_light.jpg";